export enum Queues {
  Ticket = 'ticket',
  Settings = 'settings',
  Mqtt = 'mqtt',
  AutoFire = 'auto_fire',
  Scheduler = 'scheduler',
}

export enum SettingsQueueJobs {
  KDS_UPDATE = 'kds_update',
  KDS_DOUBLE_TAP_FULFILLMENT = 'kds_double_tap_fulfillment',
  KDS_DISPLAY_AVG_FULFILLMENT_TIME = 'kds_display_avg_fulfillment_time',
  KDS_STATIONS_UPDATE = 'kds_stations_update',
  KDS_NAME_UPDATE = 'kds_name_update',
  PRINTER_STATIONS_UPDATE = 'printer_stations_update',
  TABLE_STATUS_UPDATE = 'table_status_update',
  ONHOLD_TIME_COMPLETION = 'onhold_time_completion',
  ORDER_DELAYED = 'order_delayed',
  CARD_PAYMENT = 'card_payment',
}

export enum SettingsQueueJobTarget {
  KDS = 'kds',
  POS = 'pos',
}

export enum SchedulerQueueJobs {
  SCHEDULE_TO_GRAVITON = 'schedule_to_graviton',
}

export enum TicketQueueJobs {
  New_Ticket = 'new_ticket',
  Update_Ticket = 'update_ticket',
  Update_Item = 'update_item',
  Void_Ticket = 'void_ticket',
  Void_Item = 'void_item',
  Order_Note_Update = 'order_note_update',
  Change_Table_Update = 'change_table_update',
  Change_Server_Update = 'change_server_update',
  Close_Out_Event = 'close_out_event',
  New_Catering_Ticket = 'new_catering_ticket',
  Update_Catering_Ticket = 'update_catering_ticket',
}

export enum SseLogType {
  Ticket_Send_From_Pos = 'ticket_send_from_pos',
  Job_Added_In_Queue = 'job_added_in_queue',
  Job_Worker_Started = 'job_worker_started',
  Event_Published = 'event_published',
  Event_Subscribed = 'event_subscribed',
  Ticket_Send_To_Device = 'ticket_send_to_device',
  Ticket_Can_Not_Be_Sent = 'ticket_can_not_be_sent',
  Job_Worker_Failed = 'job_worker_failed',
  Job_Marked_Completed = 'job_marked_completed',
}
